import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Card } from "@omni/ui/components/Card/card";

export const Base = ({
    children,
    className
}: RequireChildrenFor<{ className?: string }>) => {
    return (
        <Card className={className}>
            <Card.Body>{children}</Card.Body>
        </Card>
    );
};
